import {OrderDetailContext} from '../state/orderDetailContext';
import {useContext} from "react";
import {useState, useEffect} from "react";
import {Item} from "../queries/Item";
import {useUserInfo} from "../../userInfo/hooks/useUserInfo";
import {useSubmit} from "./useSubmit";


export const useOrderDetail = (id) => {
    const {state: detail, dispatch} = useContext(OrderDetailContext);
    const [loading, setLoading] = useState(true);
    const {profil} = useUserInfo();
    const { getCustomerId } = useSubmit();

    useEffect(async () => {
        if (profil) {
            const customerId = await getCustomerId(profil);
            detail.length === 0 && Item.getOrderDetailById(id, customerId)
                .then(detail => {
                    dispatch({ type: "init", payload: detail })
                    setLoading(false)
                })
                .catch( () => setLoading(false) )
        }

    }, [profil]);

    return {detail, loading}
}
